import script from "./dictionaryAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./dictionaryAdd.vue?vue&type=script&setup=true&lang=js"

import "./dictionaryAdd.vue?vue&type=style&index=0&id=1fa56ea6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fa56ea6"]])

export default __exports__